module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentUser && _vm.currentUser.userId) ? _c('modal', {
    attrs: {
      "name": "join-room-modal",
      "height": "auto",
      "pivot-y": 0.3,
      "adaptive": true,
      "width": _vm.recentConferences.length ? 817 : 428
    }
  }, [_c('div', {
    staticClass: "JoinRoom__wrapper"
  }, [_c('div', {
    staticClass: "JoinRoom__new-conf-container"
  }, [_c('div', {
    staticClass: "JoinRoom__title"
  }, [_vm._v("\n        Join Someone Else's Call\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "JoinRoom__description"
  }, [_vm._v("\n        Please enter the @username/ID and unique PIN of the conference organizer\n      ")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "joinRoom"
    }
  }, [_c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label"
  }, [_vm._v("\n            ID\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.conference.id),
      expression: "conference.id"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "username",
    staticClass: "field",
    class: {
      'is-danger': _vm.errors.has('id')
    },
    attrs: {
      "type": "text",
      "name": "id",
      "placeholder": "Enter ID of Conference Call",
      "data-vv-delay": "500",
      "data-vv-as": "ID",
      "required": ""
    },
    domProps: {
      "value": (_vm.conference.id)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.$refs.pin.focus()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.conference, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('id')),
      expression: "errors.has('id')"
    }],
    staticClass: "form-help is-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.errors.first('id')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label"
  }, [_vm._v("\n            PIN\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.conference.pin),
      expression: "conference.pin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "pin",
    staticClass: "field",
    class: {
      'is-danger': _vm.errors.has('pin')
    },
    attrs: {
      "type": "text",
      "name": "pin",
      "placeholder": "Enter PIN of Conference Call",
      "data-vv-delay": "500",
      "data-vv-as": "PIN",
      "required": ""
    },
    domProps: {
      "value": (_vm.conference.pin)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.conference, "pin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pin')),
      expression: "errors.has('pin')"
    }],
    staticClass: "form-help is-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.errors.first('pin')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-actions pull-right"
  }, [_c('a', {
    staticClass: "cancel-btn",
    on: {
      "click": function($event) {
        _vm.$modal.hide('join-room-modal')
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('a', {
    staticClass: "submit-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("join")])])])])]), _vm._v(" "), (_vm.recentConferences.length) ? _c('div', {
    staticClass: "JoinRoom__recent-conf-container"
  }, [_c('div', {
    staticClass: "JoinRoom__title"
  }, [_vm._v("\n        Or Join Recent Conference Room\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "JoinRoom__recent-conf-list"
  }, _vm._l((_vm.recentConferences), function(conf) {
    return _c('div', {
      staticClass: "JoinRoom__recent-conf-element",
      on: {
        "click": function($event) {
          _vm.joinRecent(conf)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "fallback-src",
        rawName: "v-fallback-src",
        value: ('../../../../../static/images/default-user-avatar.jpg'),
        expression: "'../../../../../static/images/default-user-avatar.jpg'"
      }],
      staticClass: "JoinRoom__recent-conf-avatar",
      attrs: {
        "src": conf.avatarUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "JoinRoom__recent-conf-username"
    }, [_vm._v("\n            @" + _vm._s(conf.username) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "JoinRoom__recent-conf-pin"
    }, [_vm._v("\n            " + _vm._s(conf.conferencePin) + "\n          ")])])
  }))]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf71330e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-menu/home-tab/join-room.modal/join-room.modal.vue
// module id = 436
// module chunks = 1